import React from 'react';
import { Fade } from 'react-awesome-reveal';

const ServiceSection = () => {
  const services = [
    {
      icon: 'fa fa-building',
      title: 'Office Interior & Fit-Outs',
      description:
        'Specialized office interior design and fit-out solutions including workstations, cabins, meeting rooms, and corporate spaces focused on productivity and branding.',
      delay: 100
    },
    {
      icon: 'fa fa-industry',
      title: 'Commercial Design & Build',
      description:
        'End-to-end design and build services for offices, showrooms, and commercial environments with seamless coordination and execution.',
      delay: 200
    },
    {
      icon: 'fa fa-pencil-ruler',
      title: 'Design, Planning & Visualization',
      description:
        'Concept design, space planning, 3D visualizations, and material selection tailored to functional requirements and project budgets.',
      delay: 300
    },
    {
      icon: 'fa fa-tools',
      title: 'Fit-Out, Installation & Renovation',
      description:
        'Turnkey execution including interior fit-outs, installations, renovations, and finishing works delivered with quality and on-time completion.',
      delay: 400
    }
  ];


  return (
    <div className="container-xxl py-6">
      <div className="container">
        <div className="row g-5">
          
          {/* Content */}
          <div className="col-lg-6">
             
            <p className="text-primarys text-uppercase mb-2">// Our Services</p>
            <h1 className="display-6 mb-4">
              Interior Design Solutions Tailored For You
            </h1>
            <p className="mb-5">
              We create thoughtful, functional, and visually stunning interiors
              that transform spaces into experiences. Our approach combines
              creativity, quality materials, and seamless execution to deliver
              spaces you’ll love.
            </p>

            <div className="row gy-5 gx-4">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="col-sm-6 wow fadeIn"
                  data-wow-delay={service.delay}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="flex-shrink-0 btn-square bg-primarys rounded-circle me-3">
                      <i className={`${service.icon} text-white`}></i>
                    </div>
                    <h5 className="mb-0">{service.title}</h5>
                  </div>
                  <span>{service.description}</span>
                </div>
              ))}
            </div>
             
          </div>

          {/* Images */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="row img-twice position-relative h-100">
              <div className="col-6">
                <img
                  className="img-fluid rounded"
                  src="/img/img13.jpg"
                  alt="Interior Design Service"
                />
              </div>
              <div className="col-6 align-self-end">
                <img
                  className="img-fluid rounded"
                  src="/img/img14.jpg"
                  alt="Interior Design Work"
                />
              </div>
            </div>
            
          </div>

        </div>
      </div>
    </div>
  );
};

export default ServiceSection;



